import {
  CalculationDetailResponse,
  CalculationMode,
  CalculationStatus,
  CalculationType,
} from '@ydistri/api-sdk';
import React, { useCallback } from 'react';
import { Button } from '@ydistri/ds';
import { TbFileImport } from 'react-icons/tb';
import {
  RedistributionDisplayMode,
  setRedistributionDisplayMode,
} from '../../../../../Calculations/calculationsSlice';
import { ReduxState, useAppDispatch } from '../../../../../../store';
import { useNavigate } from 'react-router';
import { RoutingPage } from '../../../../../../routes/routerSlice';
import { useStableParams } from '../../../../../../routes/useStableParams';
import { ROOT_CATEGORY_ID } from '../../../../../../components/global/_constants';
import { useSelector } from 'react-redux';

interface ManualCalculationImportActionProps {
  calculation: CalculationDetailResponse;
  navigateOnClick?: boolean;
}

const ManualCalculationImportAction: React.FC<ManualCalculationImportActionProps> = ({
  calculation,
  navigateOnClick = false,
}) => {
  const { projectShortName } = useStableParams();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const currentDisplayMode = useSelector(
    (state: ReduxState) => state.calculations.redistributionDisplayMode,
  );

  const clickHandler = useCallback(() => {
    if (navigateOnClick) {
      navigate(
        `/${projectShortName}/${RoutingPage.CALCULATION_DETAIL}/${calculation.id}/redistribution/${ROOT_CATEGORY_ID}`,
      );
    }
    dispatch(setRedistributionDisplayMode(RedistributionDisplayMode.IMPORT));
  }, [navigateOnClick, navigate, projectShortName, calculation.id, dispatch]);

  //Import is enabled only for manual and not production calculations
  if (
    !(
      calculation.mode === CalculationMode.Manual &&
      (calculation.type === CalculationType.Simulation ||
        calculation.type === CalculationType.Private)
    )
  ) {
    return null;
  }

  const isCalculationRunning = calculation.status === CalculationStatus.Running;

  // Disable the button if calculation is running or if we are already in import mode
  const isButtonDisabled =
    isCalculationRunning || currentDisplayMode === RedistributionDisplayMode.IMPORT;

  return (
    <Button
      type="primary"
      $textVariant="semibold"
      icon={<TbFileImport size={18} />}
      onClick={clickHandler}
      disabled={isButtonDisabled}
      loading={isCalculationRunning}
    >
      {isCalculationRunning ? 'Running' : 'Import...'}
    </Button>
  );
};

export default ManualCalculationImportAction;
